import { render, staticRenderFns } from "./RedemptionsTable.vue?vue&type=template&id=7a32d389&"
import script from "./RedemptionsTable.vue?vue&type=script&lang=js&"
export * from "./RedemptionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports